import { createContext } from 'react';
import AppContextType from '../types/AppContext.d';

export const AppContext = createContext({} as AppContextType);